export const portfolioItems = [
  {
    id: 23,
    title: "Deep Dive Dubai",
    category: "Arts, Culture & Tourism",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/mDsrpRsS/360-0011-deepdive.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746973232825!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRF90THpqYVE.!2m2!1d25.12771416659882!2d55.29469928352603!3f80.00259441310939!4f9.354546684586907!5f0.4000000000000002",
    description: "World's deepest diving pool offering unique underwater experiences and training."
  },
  {
    id: 7,
    title: "Sharjah Calligraphy Museum",
    category: "Arts, Culture & Tourism",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/Bbw43fdk/360-0027-caligraphy-SJ.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746962453736!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQzNwT3JxUWc.!2m2!1d25.35765474171099!2d55.38433708048653!3f332.09892257636824!4f-1.413570516220048!5f0.4000000000000002",
    description: "Museum showcasing the rich heritage of Arabic calligraphy and Islamic art forms."
  },
  {
    id: 22,
    title: "Vanilla Glow Beauty Salon",
    category: "Beauty & Personal Care",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/fRVkJBCY/360-0012-vanilla.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746973119600!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ19ub3otR0E.!2m2!1d25.17127996845899!2d55.30672775454864!3f189.49251722496518!4f-2.093075276112714!5f0.4000000000000002",
    description: "Premium beauty salon offering comprehensive beauty and wellness services."
  },
  {
    id: 49,
    title: "فالق الثمامة - Thumama Fault",
    category: "Arts, Culture & Tourism",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/VLc2MZv0/sls-0003-tumama.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747517448551!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRHpvTWZpT1E.!2m2!1d25.26392184079702!2d46.62680926950013!3f316.11806148341986!4f14.478327620423258!5f0.4000000000000002",
    description: "Significant historical landmark showcasing the geological marvels of Riyadh's natural landscape."
  },
  {
    id: 56,
    title: "Bu Abdullah Investment Group",
    category: "Services & Miscellaneous",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/qMJWMfp8/neww-0010-buabdullah.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1748094960525!6m8!1m7!1sCAoSHENJQUJJaENBMUxVbEU2WGF3alVWdzViTDhFNi0.!2m2!1d25.25988417083164!2d55.33667282781285!3f82.97754910275556!4f-0.6838385956174022!5f0.4000000000000002",
    description: "Investment company providing comprehensive financial and investment services for businesses and individuals."
  },
  {
    id: 57,
    title: "سحر التميز للدعاية والإعلان - Excellence Magic Advertising",
    category: "Manufacturing & Industrial",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/GhXV4Mp6/neww-0009-exellencemagic.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1748095504332!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJQ2hndjZyWFE.!2m2!1d24.67253980160918!2d46.74195363587567!3f172.12992062030995!4f-2.261080479575142!5f0.4000000000000002",
    description: "Professional advertising agency specializing in creative marketing solutions and promotional campaigns."
  },
  {
    id: 58,
    title: "Al Aqiq Al Ahmar Elect & Hardware Tr.",
    category: "Building Materials & Hardware",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/XNcTbN6j/neww-0008-alaqiqtools.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1748203355075!6m8!1m7!1sCAoSHENJQUJJaENHZjRzOEF3YlRCLXQ3Z192aWZLdXU.!2m2!1d25.36071735171998!2d55.39254501555831!3f55.79891498522993!4f-17.538772807888932!5f0.4000000000000002",
    description: "Electrical supply store offering comprehensive electrical equipment and hardware solutions for construction projects."
  },
  {
    id: 59,
    title: "Puck Arabia",
    category: "Manufacturing & Industrial",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/brTMHg9D/neww-0007-puckarabia.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1748206383705!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJRDRyNm1RUnc.!2m2!1d24.56002740388942!2d46.88368781522859!3f312.7063040039198!4f11.065756795247808!5f0.4000000000000002",
    description: "Manufacturing company specializing in industrial production and specialized manufacturing solutions."
  },
  {
    id: 60,
    title: "Golden Dune",
    category: "Home & Lifestyle",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/5thZx6t0/neww-0006-goldendue.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1748207174792!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ0JfYUNLbWdF!2m2!1d24.68832027474464!2d46.80309854354844!3f87.78386692166633!4f-1.0730265472183191!5f0.4000000000000002",
    description: "Luxury hotel offering premium accommodations and hospitality services in the heart of Riyadh."
  },
  {
    id: 61,
    title: "Lemon Pharmacy",
    category: "Services & Miscellaneous",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/1XP2q2w1/neww-0005-lemon.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1748207504355!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJRFprWXpFSHc.!2m2!1d24.80978558588998!2d46.7646363311004!3f158.52296042230037!4f-0.9431923779846301!5f0.7820865974627469",
    description: "Modern pharmacy providing comprehensive pharmaceutical services and health consultation."
  },
  {
    id: 62,
    title: "Shake It Burger",
    category: "Food & Beverage",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/W30xtTD7/neww-0004-shakeit.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1748211329514!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ0VvOWI5Q0E.!2m2!1d24.73203672897661!2d46.67781716226862!3f246.31326384460556!4f-2.704838645747131!5f0.6323622171199216",
    description: "Burger restaurant serving fresh, high-quality burgers and fast food in a modern casual dining atmosphere."
  },
  {
    id: 63,
    title: "Max",
    category: "Home & Lifestyle",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/bwJXg7Mz/neww-0003-maxriyadh.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1748293413523!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRDRyOG5XR1E.!2m2!1d24.74456656639174!2d46.6575757348516!3f317.40776946820984!4f-3.8190995744343468!5f0.4000000000000002",
    description: "Fashion retail store offering trendy clothing and lifestyle products for modern consumers."
  },
  {
    id: 64,
    title: "Aqua-Tots Swim Schools",
    category: "Home & Lifestyle",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/WbSLMN5W/neww-0002-aquatots.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1748294085227!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRDRyNm4td2dF!2m2!1d24.80151118581091!2d46.62354725554374!3f105.0642566049795!4f-10.136483206403682!5f0.4000000000000002",
    description: "Professional swimming school providing comprehensive swim lessons and water safety training for all ages."
  },
  {
    id: 65,
    title: "Brandix Fast Fashion",
    category: "Manufacturing & Industrial",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/Jzdf2TVj/neww-0001-brandiksfac.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1748294265215!6m8!1m7!1sCAoSLEFGMVFpcFBBQkk2V184OWItODBkLWVfYVhYbVY4TTZvUGRXTW10Yzl0RWEw!2m2!1d7.286904812665009!2d80.13205854164548!3f50.23324504545476!4f-27.792455408262512!5f0.4000000000000002",
    description: "Textile manufacturing facility specializing in fast fashion production and garment manufacturing."
  },
  {
    id: 66,
    title: "Teejay Group",
    category: "Manufacturing & Industrial",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/3w4s5gYV/neww-0000-teejay.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1748295289419!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRDQ3ZGVrNVFF!2m2!1d6.972281393353811!2d80.21139863624173!3f30.593636836047434!4f-5.47324814537275!5f0.4000000000000002",
    description: "Leading textile mill providing comprehensive fabric manufacturing and textile solutions for global markets."
  },
  {
    id: 67,
    title: "Shoexpress",
    category: "Home & Lifestyle",
    country: "Saudi Arabia",
    location: "Jeddah",
    thumbnailUrl: "https://i.postimg.cc/YjcdTTpt/X-0009-shewxpress.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1749400017366!6m8!1m7!1sCAoSLEFGMVFpcE9lUEVlMXVkRTRGQldES1NyMHktQ3pHZGxVaFI2TENzc19FMjJV!2m2!1d21.59528671145761!2d39.17583278347071!3f163.44093800647406!4f-11.368212147189922!5f0.4000000000000002",
    description: "Modern shoe store offering a wide variety of footwear for men, women, and children with the latest fashion trends."
  },
  {
    id: 68,
    title: "Hafele Design Centre",
    category: "Home & Lifestyle",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/2yLHcCNH/X-0008-hafele.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1749401129338!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRFVtZS02bmdF!2m2!1d6.885073946117268!2d79.86049104781047!3f288.65697662253!4f-28.99240039269094!5f0.4000000000000002",
    description: "Premium home improvement store showcasing modern interior design solutions and high-quality hardware products."
  },
  {
    id: 69,
    title: "Zenith Dentistry",
    category: "Beauty & Personal Care",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/vmXSDPvv/X-0007-zenith.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1749401562948!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRDQ3ZWUzM3dF!2m2!1d6.863299123662816!2d79.86706216631632!3f301.6538660844646!4f-19.510854582846193!5f0.4000000000000002",
    description: "Modern dental clinic providing comprehensive oral healthcare services with state-of-the-art equipment and professional care."
  },
  {
    id: 70,
    title: "Mandarina Colombo",
    category: "Home & Lifestyle",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/PqdRXG1x/X-0006-mandarina.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1749402278551!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRDQ3YS1pMndF!2m2!1d6.900221798286688!2d79.85372432211747!3f324.3555160186153!4f0.9301586421818229!5f0.4000000000000002",
    description: "Elegant hotel offering luxurious accommodations and exceptional hospitality services in the heart of Colombo."
  },
  {
    id: 71,
    title: "Wild Wadi Wilpattu",
    category: "Home & Lifestyle",
    country: "Sri Lanka",
    location: "Wilpattu",
    thumbnailUrl: "https://i.postimg.cc/Sx6PbQ23/X-0005-wildwadi.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1749418315072!6m8!1m7!1sCAoSHENJQUJJaEJpSDZkMGZHa055ZXhfS0U0RmtqVTg.!2m2!1d8.267437258560905!2d79.86876769718454!3f32.41929837566562!4f-0.6447276248360794!5f0.4000000000000002",
    description: "Eco-friendly hotel located near Wilpattu National Park offering nature-based accommodation and wildlife experiences."
  },
  {
    id: 72,
    title: "Scope Cinemas Multiplex - CCC",
    category: "Home & Lifestyle",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/fRnPPSLY/X-0004-scope.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1749418438177!6m8!1m7!1sCAoSLEFGMVFpcE9TbmxWYm0yLUtaSFFsWURRY0FvZWpPZTNPWmVlUUlxbnVXM0lx!2m2!1d6.917824836357599!2d79.85563590764428!3f14.876296504430064!4f1.1840790926524676!5f0.4000000000000002",
    description: "Modern movie theater complex offering the latest films with premium viewing experience and comfortable seating."
  },
  {
    id: 73,
    title: "Hemas Hospital",
    category: "Home & Lifestyle",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/MHgLqvY2/X-0003-hemas.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1749418832644!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ1VqWnFucUFF!2m2!1d6.988733753277258!2d79.89124405225601!3f17.203359769976096!4f-6.506000525214546!5f0.4000000000000002",
    description: "Leading private hospital providing comprehensive healthcare services with advanced medical technology and expert care."
  },
  {
    id: 74,
    title: "Colombo Lotus Tower",
    category: "Arts, Culture & Tourism",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/MZLNyFJP/X-0002-lotus.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1749419423978!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJQzB0ZXkxUkE.!2m2!1d6.926865509483127!2d79.85820670137596!3f151.0814884278499!4f2.913743412612803!5f0.4000000000000002",
    description: "Iconic tower and tourist attraction offering panoramic views of Colombo and serving as a telecommunications hub."
  },
  {
    id: 75,
    title: "Bellagio Colombo",
    category: "Home & Lifestyle",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/rFtbgN88/X-0001-bellagio.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1749419542860!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJQ3N0YXJJRnc.!2m2!1d6.904909796212969!2d79.85363458332516!3f339.68687002414055!4f-2.2044055298758423!5f0.7820865974627469",
    description: "Luxury casino and entertainment complex offering gaming facilities, dining, and nightlife entertainment."
  },
  {
    id: 76,
    title: "Jananam Indo Lanka Fertility Center",
    category: "Home & Lifestyle",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/sxMLkp74/X-0000-jananam.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1749420103765!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRDQ3YWVCaXdF!2m2!1d6.900631411207548!2d79.85434180799932!3f186.2989049257011!4f-13.193993246579396!5f0.4000000000000002",
    description: "Specialized fertility clinic providing advanced reproductive healthcare services and fertility treatments with expert medical care."
  },
  {
    id: 100,
    title: "Zaidoon Al Dabbagh Auto Spare Parts LLC",
    category: "Automotive-Related Businesses",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/vBYs6myC/360-0033-Zaidoon.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746959728011!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ0g4LXJFemdF!2m2!1d25.33237547469658!2d55.40588004354971!3f280.4558296123165!4f-5.94418056419272!5f0.7820865974627469",
    description: "Auto body shop specializing in spare parts and automotive accessories for various vehicle types."
  },
  {
    id: 101,
    title: "Al Sughra Building Material Trading LLC",
    category: "Building Materials & Hardware",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/6QLK3vkd/360-0032-alsugra-SJ.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746961008119!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJREg5OXZTdlFF!2m2!1d25.31813795805358!2d55.40863801171793!3f196.71378927626228!4f-3.062961742277892!5f0.4000000000000002",
    description: "Building materials trading company offering comprehensive construction supplies and hardware solutions."
  },
  {
    id: 102,
    title: "Kandy Cars Trading",
    category: "Automotive-Related Businesses",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/GmDrWNzg/360-0031-Kandycar.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746960942982!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJQ1htSUtLUVE.!2m2!1d25.34064738596535!2d55.47859861956415!3f285.0507106622793!4f-2.066853717671222!5f0.7820865974627469",
    description: "Car trading company specializing in vehicle sales and automotive services in Sharjah."
  },
  {
    id: 103,
    title: "Lattafa Trading LLC",
    category: "Beauty & Personal Care",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/L6w20RkZ/360-0030-lattafa.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746961458186!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ25oOTZObUFF!2m2!1d25.3515864111747!2d55.62392193149944!3f168.5850078245371!4f-2.8792540312097543!5f0.4000000000000002",
    description: "Beauty and personal care trading company offering quality cosmetics and fragrance products."
  },
  {
    id: 104,
    title: "Luxury Wheels Automobiles Services",
    category: "Automotive-Related Businesses",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/15fyH4FQ/360-0029-luxurywheels.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746962062064!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRG5tTWZXN0FF!2m2!1d25.11190771307076!2d55.23470416036216!3f215.04114409007477!4f-3.158278663890812!5f0.4000000000000002",
    description: "Luxury automobile service center providing premium car maintenance and automotive solutions."
  },
  {
    id: 105,
    title: "Magic Touch Advertising LLC",
    category: "Services & Miscellaneous",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/s2RyscNj/360-0028-magictouch.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746962335029!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJRG5rOUhjVVE.!2m2!1d25.29759769517639!2d55.38931228226136!3f75.31814411653433!4f-7.3117873543614!5f0.4000000000000002",
    description: "Professional advertising agency providing creative marketing solutions and promotional services."
  },
  {
    id: 106,
    title: "Paws and Whiskers Pets Nursery",
    category: "Specialty Retail",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/59PxL86g/360-0026-petshop1.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746964738718!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJQ1gwcWY0Unc.!2m2!1d25.11391023495668!2d55.22126487767784!3f215.18439591254727!4f-1.6394857656697042!5f0.4000000000000002",
    description: "Pet nursery and care facility providing comprehensive pet supplies and grooming services."
  },
  {
    id: 107,
    title: "Babyshop - Al Raas 2",
    category: "Specialty Retail",
    country: "UAE",
    location: "Umm Al Quwain",
    thumbnailUrl: "https://i.postimg.cc/L5s2G80j/360-0025-babyshop.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746964872420!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRFhsTWFOemdF!2m2!1d25.55527129380445!2d55.54803751117331!3f241.0209625771032!4f-0.719001842315464!5f0.4000000000000002",
    description: "Specialized baby store offering quality products and accessories for infants and toddlers."
  },
  {
    id: 108,
    title: "Pedlar's Gelato & Cafe Dubai",
    category: "Food & Beverage",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/tTk9rxDX/360-0024-pedlers.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746969211291!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJRFhtWXVRRHc.!2m2!1d25.24724018045375!2d55.2774601788516!3f182.75633000437026!4f2.83675951897861!5f0.4000000000000002",
    description: "Artisanal gelato shop and cafe offering premium ice cream and coffee in a cozy atmosphere."
  },
  {
    id: 109,
    title: "Tylu Kreations",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/zfnzgMgH/360-0023-tylu.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746970543214!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRFhvNktod1FF!2m2!1d25.35015076769149!2d55.62302565994323!3f130.78173603591898!4f-7.1611760804075!5f0.4000000000000002",
    description: "Creative design company specializing in innovative lifestyle products and custom solutions."
  },
  {
    id: 110,
    title: "Nomads Roastery",
    category: "Food & Beverage",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/qR4kXLsb/360-0022-nomad.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746970818385!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJQ1BfclhyRFE.!2m2!1d25.16970643745111!2d55.34681455015716!3f344.82445109579714!4f-4.47714876081119!5f0.4000000000000002",
    description: "Specialty coffee roastery offering freshly roasted beans and artisanal coffee experiences."
  },
  {
    id: 111,
    title: "Aam Alfain Auto Accessories LLC",
    category: "Automotive-Related Businesses",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/g09crdnP/360-0021-2000k.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746971020875!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJRFA3czZfZlE.!2m2!1d25.30906052583232!2d55.3926543799803!3f334.64233555870305!4f2.358958362578818!5f0.4000000000000002",
    description: "Auto accessories store providing comprehensive automotive parts and enhancement solutions."
  },
  {
    id: 112,
    title: "Turkmenistan Auto Spare Parts",
    category: "Automotive-Related Businesses",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/RZJVMqCR/360-0020-turmanistan.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746971243491!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRF9yUE9LeGdF!2m2!1d25.31234808481333!2d55.3982040237636!3f267.1217778248635!4f1.0023144438507643!5f0.4000000000000002",
    description: "Auto spare parts supplier specializing in quality replacement parts for various vehicle models."
  },
  {
    id: 113,
    title: "Ideal Fibreglass & Plastic Factory Ltd",
    category: "Manufacturing & Industrial",
    country: "UAE",
    location: "Umm Al Quwain",
    thumbnailUrl: "https://i.postimg.cc/DyMwk1h0/360-0019-Idealfiber.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746971488682!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ3Z4Wm5GeEFF!2m2!1d25.55589620151785!2d55.67949651280355!3f67.24121683307727!4f2.177200744072877!5f0.4000000000000002",
    description: "Manufacturing facility specializing in fiberglass and plastic products for industrial applications."
  },
  {
    id: 114,
    title: "Howlin' Rooster Guitars and Suc",
    category: "Manufacturing & Industrial",
    country: "UAE",
    location: "Umm Al Quwain",
    thumbnailUrl: "https://i.postimg.cc/NfMjzpWZ/360-0018-guitar.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746974235120!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJQ3YzZWp4R2c.!2m2!1d25.55604347772881!2d55.67946745138273!3f272.6071253071384!4f-0.6739042753119833!5f0.4000000000000002",
    description: "Musical instrument manufacturer specializing in custom guitars and musical equipment."
  },
  {
    id: 115,
    title: "Al Istaqlal",
    category: "Services & Miscellaneous",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/cC1LZm6g/360-0017-forlklift.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746972021057!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRHZnOXFqemdF!2m2!1d25.31264836909449!2d55.42685578571032!3f201.24540888561188!4f1.8543649481931936!5f0.4000000000000002",
    description: "Car repair and maintenance service providing comprehensive automotive solutions and fleet management."
  },
  {
    id: 116,
    title: "Irepair Auto Services LLC",
    category: "Automotive-Related Businesses",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/Hx9kfKW1/360-0016-i-Repear.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746972170085!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ181NE8ydkFF!2m2!1d25.1845392546652!2d55.34283849223931!3f76.43140478518863!4f1.219385227844441!5f0.4000000000000002",
    description: "Professional auto repair services offering comprehensive vehicle maintenance and diagnostic solutions."
  },
  {
    id: 117,
    title: "Georgia Auctions & Used Cars Trading LLC",
    category: "Automotive-Related Businesses",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/T2QP0ZHr/360-0015-geoargia.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746972340379!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRGZ5YU9xdWdF!2m2!1d25.31302261556782!2d55.39900974472413!3f270.3703895384596!4f2.52205158619239!5f0.7820865974627469",
    description: "Used car dealership and auction house providing quality pre-owned vehicles and automotive trading services."
  },
  {
    id: 118,
    title: "Dar Al Mamounia Restaurant",
    category: "Food & Beverage",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/wMWTBmsW/360-0014-daralmaimona.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746972715017!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJRGZuNjZXSmc.!2m2!1d25.23269958579708!2d55.26567097847842!3f13.707580750803213!4f-8.583597191928405!5f0.4000000000000002",
    description: "Traditional restaurant offering authentic Middle Eastern cuisine in an elegant dining atmosphere."
  },
  {
    id: 119,
    title: "Al Jedar Trading",
    category: "Building Materials & Hardware",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/L8G5fLQw/360-0013-aljader.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746972919561!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ19fZVN6dEFF!2m2!1d25.2938350681394!2d55.4387573405618!3f148.29251328821587!4f-0.4021178899818807!5f0.4000000000000002",
    description: "Trading company specializing in building materials and hardware supplies for construction projects."
  },
  {
    id: 120,
    title: "Spc Free Zone",
    category: "Services & Miscellaneous",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/Zq3RLn1R/360-0010-spc.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746973338724!6m8!1m7!1sCAoSHENJQUJJaEFEeWNKejdpNHRwbWZ2Y0p3QUFsTUw.!2m2!1d25.31984391728464!2d55.45818370583018!3f59.94486784470955!4f0.17010673548251987!5f0.4000000000000002",
    description: "Free zone services provider offering business setup and corporate solutions for international companies."
  },
  {
    id: 121,
    title: "Asbm",
    category: "Building Materials & Hardware",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/MKPv6h7W/360-0009-ASBM.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746973468920!6m8!1m7!1sCAoSHENJQUJJaEFBM2pVM05pOUlZbWV3NEw0QUNWMXU.!2m2!1d25.11110145112299!2d55.22471873425424!3f142.34851290096947!4f0.6894402997288722!5f0.4000000000000002",
    description: "Building materials supplier providing comprehensive construction materials and hardware solutions."
  },
  {
    id: 122,
    title: "Wow General Trading LLC",
    category: "Specialty Retail",
    country: "UAE",
    location: "Ajman",
    thumbnailUrl: "https://i.postimg.cc/PrrCkt83/360-0008-wow.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746973587926!6m8!1m7!1sCAoSHENJQUJJaEFEeWNKenpqYUNYV2ZBemVrQUJpdFU.!2m2!1d25.38184081252434!2d55.46412192018613!3f279.00352549340874!4f-5.340435163355735!5f0.4000000000000002",
    description: "General trading company offering a wide variety of consumer goods and specialty retail products."
  },
  {
    id: 123,
    title: "Al Mouj Al Abyadh",
    category: "Services & Miscellaneous",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/fWvVF3kS/360-0007-almaujalabyal.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746973711664!6m8!1m7!1sCAoSHENJQUJJaEFEeWM1VVZRNnhEMmZDV0c0QUFZTDY.!2m2!1d25.32284248439922!2d55.40436291112633!3f262.6737303062483!4f-13.26617694411091!5f0.4000000000000002",
    description: "Service provider offering specialized business solutions and consulting services in Sharjah."
  },
  {
    id: 124,
    title: "Mustafa Ashqar Trading LLC Umm Ramool",
    category: "Manufacturing & Industrial",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/FRyYhzZq/360-0006-mustafa1.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746973865488!6m8!1m7!1sCAoSHENJQUJJaEFBM2lsV1poa2hFR2Z4RFcwQUQwR3M.!2m2!1d25.22965743335689!2d55.35498002256887!3f69.38826257862348!4f-1.9300841053775883!5f0.4000000000000002",
    description: "Industrial trading company specializing in manufacturing equipment and industrial supplies."
  },
  {
    id: 125,
    title: "Casa Mikoko",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Umm Al Quwain",
    thumbnailUrl: "https://i.postimg.cc/8cwsrYxm/360-0005-kasa.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746974051406!6m8!1m7!1sCAoSHENJQUJJaEFEeWNKejdpNHRwbWZ6c0xzQUNXb2U.!2m2!1d25.53896148874686!2d55.62787393250864!3f12.120366906534928!4f-1.2767593821695442!5f0.4000000000000002",
    description: "Lifestyle destination offering unique home decor and lifestyle products in a modern setting."
  },
  {
    id: 126,
    title: "Universal Wheels Trading LLC",
    category: "Building Materials & Hardware",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/x89c8Qpd/360-0004-maxwel.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746974367862!6m8!1m7!1sCAoSHENJQUJJaEFEeWRWZ016amQwbWdLT21VQURQbnY.!2m2!1d25.31888579841104!2d55.40065668184991!3f83.04307610067659!4f4.428090994758392!5f0.4000000000000002",
    description: "Trading company specializing in building materials and hardware supplies for construction industry."
  },
  {
    id: 127,
    title: "Mustafa Ashqar Trading LLC",
    category: "Manufacturing & Industrial",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/XYqB9VjG/360-0003-mustafa2.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746974506319!6m8!1m7!1sCAoSHENJQUJJaEFEeWNJemilEZ0ZNDBIV2dLUEZnQURsOEw.!2m2!1d25.26959074154793!2d55.3044727209551!3f234.4201688195526!4f2.0475738942724178!5f0.4000000000000002",
    description: "Manufacturing and trading company providing industrial products and manufacturing solutions."
  },
  {
    id: 128,
    title: "Baf Home (Aseel Furniture)",
    category: "Manufacturing & Industrial",
    country: "UAE",
    location: "Ajman",
    thumbnailUrl: "https://i.postimg.cc/3xq4BPNL/360-0002-bait.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746974849307!6m8!1m7!1sCAoSHENJQUJJaERfaTlwb3FOYTd5TmMtcmF4bmlPNV8.!2m2!1d25.3896889375518!2d55.48541067968425!3f332.4680664850439!4f0.36813595214533734!5f0.4000000000000002",
    description: "Furniture manufacturer and home decor specialist offering custom and ready-made furniture solutions."
  },
  {
    id: 129,
    title: "Kitesurf Beach Centre",
    category: "Arts, Culture & Tourism",
    country: "UAE",
    location: "Umm Al Quwain",
    thumbnailUrl: "https://i.postimg.cc/FKJfnDJh/360-0001-kite.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746975068952!6m8!1m7!1sCAoSHENJQUJJaEMyeU9HMVhfTXVmeVB6RDdpY25QazI.!2m2!1d25.54730503675811!2d55.53688072582671!3f329.80654880114497!4f3.7771541154628494!5f0.4000000000000002",
    description: "Kitesurfing and water sports center offering lessons and equipment rental for beach activities."
  },
  {
    id: 130,
    title: "Zguard Auto Care LLC",
    category: "Automotive-Related Businesses",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/SsFX0CWC/360-0000-zguard.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1746975145758!6m8!1m7!1sCAoSHENJQUJJaEFfU2pIbW84eWxDV3c2MFhTZDBZd2Y.!2m2!1d25.14061094155051!2d55.25890531216096!3f251.34241102202384!4f0.9226939474116449!5f0.4000000000000002",
    description: "Auto care service center providing professional vehicle maintenance and protection services."
  },
  {
    id: 131,
    title: "Tools and More General Trading LLC",
    category: "Building Materials & Hardware",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/Njy8jZyH/360-0034-toolsmore.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747347153394!6m8!1m7!1sCAoSHENJQUJJaEF2SmtMVF90dmxoUUprb0pBY0k4UUo.!2m2!1d25.1851292!2d55.3519239!3f349.9549173163006!4f-1.2859407454305796!5f0.4000000000000002",
    description: "Tool store providing comprehensive hardware tools and equipment for professional and personal use."
  },
  {
    id: 200,
    title: "Sri Lanka Planetarium",
    category: "Arts, Culture & Tourism",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/cLZ7F1hB/nw-0005-planatarium.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747420343672!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ1U3dXVld3dF!2m2!1d6.900746190529244!2d79.86295402485183!3f233.50092781028323!4f18.51122589146148!5f0.4000000000000002",
    description: "Educational planetarium offering astronomical shows and space science exhibitions for visitors of all ages."
  },
  {
    id: 201,
    title: "Halpewatte Tea Factory",
    category: "Arts, Culture & Tourism",
    country: "Sri Lanka",
    location: "Ella",
    thumbnailUrl: "https://i.postimg.cc/NMyRKKGB/nw-0009-halpetea.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747420847989!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJRDQ3YmZIUGc.!2m2!1d6.889737238117521!2d81.03481432117034!3f262.4286582006838!4f-2.624648945389737!5f0.4000000000000002",
    description: "Traditional tea factory offering guided tours and insights into Ceylon tea production processes."
  },
  {
    id: 202,
    title: "Brandix Knit Centre",
    category: "Manufacturing & Industrial",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/rpZSy1kf/nw-0008-brandixknit.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747421294524!6m8!1m7!1sCAoSLEFGMVFpcFBLOUxnTmVrNEVmM0dxcHZMb1RoSEwwQV82aXFKc3RRWWRlWmRo!2m2!1d7.021022506362631!2d79.9107239065719!3f332.9907230282541!4f-6.249923629823925!5f0.4000000000000002",
    description: "Knitwear manufacturing facility producing high-quality textile products for international markets."
  },
  {
    id: 203,
    title: "UTE CAT - Sri Lanka",
    category: "Manufacturing & Industrial",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/DzwrKCtW/nw-0007-catsrilanka.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747421549179!6m8!1m7!1sCAoSHENJQUJJaEFEeWRFUjRSb1RqbWZicUprQUJHeWg.!2m2!1d6.999029925265346!2d79.8981274863763!3f71.09643543054838!4f-9.32604575424358!5f0.4000000000000002",
    description: "Construction equipment supplier providing heavy machinery and industrial equipment solutions."
  },
  {
    id: 204,
    title: "98 Acres Resort & Spa",
    category: "Home & Lifestyle",
    country: "Sri Lanka",
    location: "Ella",
    thumbnailUrl: "https://i.postimg.cc/pLZf4N1b/nw-0006-98acers.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747424685159!6m8!1m7!1sCPk74ZQ-Lq4AAAQvOqEOHw!2m2!1d6.870956450211002!2d81.06292813322007!3f309.89059532127163!4f-4.423338553937441!5f0.4000000000000002",
    description: "Luxury resort and spa offering scenic mountain views and premium hospitality in the hill country."
  },
  {
    id: 205,
    title: "Rosewood Ceylon",
    category: "Home & Lifestyle",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/wTDc5RXB/nw-0004-rosewood.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747424970576!6m8!1m7!1sCAoSLEFGMVFpcE5vZHNPR01ub09MbmlLNVh0bDZKOXpOMnpBeTJ0SzhDYUs2aXRa!2m2!1d6.862913981252085!2d79.8673370667294!3f116.02497204296708!4f5.52241429586411!5f0.4000000000000002",
    description: "Elegant banquet hall and event venue providing luxury facilities for weddings and corporate events."
  },
  {
    id: 206,
    title: "Flying Ravana Mega Zipline",
    category: "Arts, Culture & Tourism",
    country: "Sri Lanka",
    location: "Ella",
    thumbnailUrl: "https://i.postimg.cc/pVhBT6yz/nw-0003-falyingrawana.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747425550978!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRDQ3ZE9xdWdF!2m2!1d6.865741162716924!2d81.06235754921855!3f213.55460743738794!4f-19.457621355333913!5f0.4000000000000002",
    description: "Adventure sports center featuring the world's largest zipline offering thrilling aerial experiences."
  },
  {
    id: 207,
    title: "Akrams Hardware",
    category: "Building Materials & Hardware",
    country: "Sri Lanka",
    location: "Galle",
    thumbnailUrl: "https://i.postimg.cc/kM0vtvtZ/nw-0002-akrams.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747425823815!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJRDQ3YS00WkE.!2m2!1d6.036118568736833!2d80.22092443378178!3f20.409670776043043!4f-8.180594732368277!5f0.4000000000000002",
    description: "Hardware store providing comprehensive building materials and construction supplies for local projects."
  },
  {
    id: 208,
    title: "Garton's Ark Restaurant",
    category: "Food & Beverage",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/hvd85fNp/nw-0001-gartonark.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747426221115!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJRGt6Yl9UWEE.!2m2!1d6.883246610502243!2d79.89256340892872!3f291.6042119447565!4f-12.925040682803882!5f0.4000000000000002",
    description: "Restaurant offering delicious cuisine and dining experiences in a comfortable and welcoming atmosphere."
  },
  {
    id: 209,
    title: "Prime Life",
    category: "Home & Lifestyle",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/PxczymVC/nw-0000-primelife.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747426469385!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ0U4N2VldVFF!2m2!1d6.990931070703181!2d79.95992100959832!3f200.82903412227552!4f-19.1923241164331!5f0.4000000000000002",
    description: "Housing complex providing modern residential accommodations and lifestyle amenities for urban living."
  },
  {
    id: 210,
    title: "Bombay Borough",
    category: "Food & Beverage",
    country: "Sri Lanka",
    location: "Colombo",
    thumbnailUrl: "https://i.postimg.cc/2ynJMhc5/sls-0000-bombay.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747488805722!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ3M2cnJGOXdF!2m2!1d6.926655715152495!2d79.84474888006322!3f252.684533484159!4f0.2532533614610628!5f0.4000000000000002",
    description: "Indian restaurant serving authentic Indian cuisine with traditional flavors and modern presentation."
  },
  {
    id: 211,
    title: "Le Jardin du Fort",
    category: "Home & Lifestyle",
    country: "Sri Lanka",
    location: "Galle",
    thumbnailUrl: "https://i.postimg.cc/HkFwcRWf/slss-0000-lejardin.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747523033282!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRDQ3WV9uaXdF!2m2!1d6.025992413044442!2d80.21864421193146!3f98.43986582985697!4f2.0606244996827314!5f0.4000000000000002",
    description: "Boutique hotel offering charming accommodations and personalized service in historic Galle Fort."
  },
  {
    id: 212,
    title: "W15 Hanthana Estate",
    category: "Home & Lifestyle",
    country: "Sri Lanka",
    location: "Kandy",
    thumbnailUrl: "https://i.postimg.cc/tR6LsGqH/sls-0001-w15.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747509607418!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJQ0MzOG52R3c.!2m2!1d7.249930048517951!2d80.63201998774873!3f140.3054483186592!4f-0.7627852830188573!5f0.4000000000000002",
    description: "Luxury hotel nestled in the hills offering premium accommodation with stunning natural surroundings."
  },
  {
    id: 213,
    title: "Walaa Kulu by Vella",
    category: "Home & Lifestyle",
    country: "Sri Lanka",
    location: "Ella",
    thumbnailUrl: "https://i.postimg.cc/Kz6w0J5V/sls-0002-walakulu.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747517160706!6m8!1m7!1sCAoSFkNJSE0wb2dLRUlDQWdJREpobzNqVWc.!2m2!1d6.890157196127414!2d81.03571329983326!3f53.40798594834273!4f1.3900822548135636!5f0.7820865974627469",
    description: "Exclusive villa accommodation offering luxury stays with panoramic views of Ella's scenic landscape."
  },
  {
    id: 300,
    title: "حلويات روز - Rose Sweets",
    category: "Food & Beverage",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/P5XcVLmt/sls-0004-rose.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747517879553!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ3h2c3ZLcVFF!2m2!1d24.59249546458578!2d46.64938797436205!3f250.11883010796558!4f-1.9518641807712953!5f0.7820865974627469",
    description: "Traditional candy store offering premium sweets and confectionery products with authentic Middle Eastern flavors."
  },
  {
    id: 301,
    title: "Ajam Specialty Coffee",
    category: "Food & Beverage",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/Qdfz2Xbc/sls-0005-ajam.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747518258795!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ3hfcTJqd0FF!2m2!1d24.69955986964348!2d46.6808785234611!3f47.467614286872625!4f-5.137766324087224!5f0.7820865974627469",
    description: "Specialty coffee shop offering premium coffee blends and artisanal brewing methods for coffee enthusiasts."
  },
  {
    id: 302,
    title: "Kids World Barber",
    category: "Beauty & Personal Care",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/hGhYgHy6/sls-0006-worldkids.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747518825639!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRDRyNW5uaWdF!2m2!1d24.66057731419262!2d46.78275442237189!3f205.5783773132827!4f-11.59351995782356!5f0.7820865974627469",
    description: "Children's barber shop providing professional haircuts and grooming services specifically designed for kids."
  },
  {
    id: 303,
    title: "Soor Media Advertising Group",
    category: "Manufacturing & Industrial",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/66GyTq45/slss-0000-soor.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747519124289!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ0JxdGpWOEFF!2m2!1d24.66049272930524!2d46.71139699964547!3f9.615850665186368!4f-3.9271262853403073!5f0.7820865974627469",
    description: "Digital printing and advertising service provider offering comprehensive marketing and promotional solutions."
  },
  {
    id: 304,
    title: "Braira Al Wezarat Hotel",
    category: "Home & Lifestyle",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/SN73GLYT/sls-0007-baraira.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747521339916!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ0I0NDNaN3dF!2m2!1d24.67404841520479!2d46.71808795699187!3f260.63054177218106!4f-7.955582776019895!5f0.7820865974627469",
    description: "Business hotel offering comfortable accommodations and professional services for corporate travelers."
  },
  {
    id: 305,
    title: "Karim Hotel",
    category: "Home & Lifestyle",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/Jhg2hPSn/sls-0008-karim.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1747521658879!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRHAtY1dRaWdF!2m2!1d24.75495201333106!2d46.70602710860621!3f3.797940884030054!4f-4.868638399614866!5f0.4000000000000002",
    description: "Traditional hotel providing authentic hospitality and comfortable accommodation in the heart of Riyadh."
  },
  {
    id: 306,
    title: "Fashion Zone",
    category: "Beauty & Personal Care",
    country: "UAE",
    location: "Ajman",
    thumbnailUrl: "https://i.postimg.cc/NjdKBLcy/new01-fashionzone.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1753904181615!6m8!1m7!1sCAoSHENJQUJJaEFmY05fNTRQT0MwLS1TRWwtWEg1aEU.!2m2!1d25.37814314711119!2d55.46043698503374!3f162.5979746956161!4f-4.5767884387527005!5f0.4000000000000002",
    description: "Fashion Zone offers a comprehensive collection of ladies, mens and kids clothing, accessories and footwear for the entire family."
  },
  {
    id: 307,
    title: "Ms Max Ajman",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Ajman",
    thumbnailUrl: "https://i.postimg.cc/hGhfjgD2/new01-msmaxajman.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1753905175993!6m8!1m7!1sCAoSHENJQUJJaEQyVkZZd2FWN0NyWlJTb3VZcDh2d1M.!2m2!1d25.43122979396304!2d55.52293451367818!3f142.44067047547733!4f-0.3199891694885224!5f0.4000000000000002",
    description: "Ms Max Ajman is a modern department store offering a wide variety of products including clothing, home goods, electronics and daily essentials."
  },
  {
    id: 308,
    title: "Al Aqiq Al Ahmar Elect & Hardware Tr.",
    category: "Building Materials & Hardware",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/XNcTbN6j/neww-0008-alaqiqtools.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1748203355075!6m8!1m7!1sCAoSHENJQUJJaENHZjRzOEF3YlRCLXQ3Z192aWZLdXU.!2m2!1d25.36071735171998!2d55.39254501555831!3f55.79891498522993!4f-17.538772807888932!5f0.4000000000000002",
    description: "Al Aqiq Al Ahmar specializes in electrical and electronics components, hardware tools and building materials for residential and commercial projects."
  },
  {
    id: 309,
    title: "Bermuda Diving Center",
    category: "Arts, Culture & Tourism",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/zXVJZrmh/1-bermuda.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1756754863284!6m8!1m7!1sCAoSHENJQUJJaEJKUGxFMlFQNTRpOUNPUUpuLWNVYUI.!2m2!1d25.18480617906509!2d55.23791998752956!3f312.7208291472104!4f0.6271834999322436!5f0.4000000000000002",
    description: "Bermuda Diving Center offers professional diving services and underwater exploration experiences in Dubai's pristine waters with certified instructors and modern equipment."
  },
  {
    id: 310,
    title: "Super Land Auto Spare Parts Tr.Co.LLC",
    category: "Automotive-Related Businesses",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/HnPdcSMj/2-superland.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1756755447783!6m8!1m7!1sCAoSHENJQUJJaEF3T1NOVlJkaEJ2MS1mMlJGWjdTaVc.!2m2!1d25.32473510897602!2d55.40564616254285!3f356.0520017282515!4f0.027971163361996787!5f0.4000000000000002",
    description: "Super Land Auto Spare Parts is a comprehensive automotive parts trading company in Sharjah, offering quality spare parts and accessories for all vehicle makes and models."
  },
  {
    id: 311,
    title: "Al Shaab Furniture",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Ajman",
    thumbnailUrl: "https://i.postimg.cc/Y2XpsSPk/3-alshaab-furniture.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1756755654831!6m8!1m7!1sCAoSHENJQUJJaERGOXNVTnlBbkVsZUtjN24yd3oxZEU.!2m2!1d25.40622333415408!2d55.4439610156873!3f55.86808872459024!4f0.18753616323245126!5f0.4000000000000002",
    description: "Al Shaab Furniture showcases an extensive collection of modern and traditional furniture pieces, offering stylish solutions for homes and offices across the UAE."
  },
  {
    id: 312,
    title: "Safeer Mall - Ajman",
    category: "Services & Miscellaneous",
    country: "UAE",
    location: "Ajman",
    thumbnailUrl: "https://i.postimg.cc/ZnqJqkC1/4-safeer-mall.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1756755978150!6m8!1m7!1sCAoSHENJQUJJaEJvV0xiTHNxZi1HY3ItM3hsQWhKMy0.!2m2!1d25.39005773757206!2d55.44514395436391!3f281.17614236521706!4f-2.2304211346799008!5f0.4000000000000002",
    description: "Safeer Mall Ajman is a modern shopping destination featuring diverse retail outlets, dining options, and entertainment facilities serving the local community and visitors."
  },
  {
    id: 313,
    title: "Yogi Group",
    category: "Services & Miscellaneous",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/02F99BxB/5-yogi-group.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1756756901345!6m8!1m7!1sCAoSHENJQUJJaEF5eHFaMjZFQTZEUE44V1hEZnd2Wk0.!2m2!1d25.18397921675106!2d55.26085997636281!3f78.26764701465528!4f-0.4092457199439252!5f0.4000000000000002",
    description: "Yogi Group is a dynamic corporate office providing comprehensive business solutions and services across various industries with a focus on innovation and excellence."
  },
  {
    id: 314,
    title: "Al Faiz Elect & Hard ware Tr. LLC",
    category: "Building Materials & Hardware",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/MG8xQfn0/6-alfaiz.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1756769009885!6m8!1m7!1sCAoSHENJQUJJaENHZWV3cUxmNzNwLVlqMUt0ZWZWNjQ.!2m2!1d25.3191281689109!2d55.4003476465026!3f297.0462178687408!4f-3.655698759180396!5f0.4000000000000002",
    description: "Al Faiz specializes in electrical components, hardware tools, and building materials, serving contractors and construction professionals throughout Sharjah with quality products."
  },
  {
    id: 315,
    title: "Flexipack Trading LLC",
    category: "Manufacturing & Industrial",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/wjNgMQjT/7-flexipack.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1756769303316!6m8!1m7!1sCAoSHENJQUJJaEFPclRLUllaY3hiSjBkWGlIbEczM2k.!2m2!1d25.29455475596742!2d55.43709329128684!3f204.80257676306553!4f-3.1461196131155873!5f0.4000000000000002",
    description: "Flexipack Trading LLC is a leading supplier specializing in flexible packaging solutions and industrial materials, catering to diverse manufacturing and commercial needs."
  },
  {
    id: 316,
    title: "Al Daraan Trading Company",
    category: "Services & Miscellaneous",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/QMkDkN72/8-aldaraan.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1756769649536!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJRHVfN19taUFF!2m2!1d24.65372927943673!2d46.81473814233102!3f108.82676729718881!4f-1.3629380247955254!5f0.4000000000000002",
    description: "Al Daraan Trading Company operates a modern supermarket in Riyadh, offering a comprehensive selection of groceries, fresh produce, and household essentials for local families."
  },
  {
    id: 317,
    title: "Lucidya",
    category: "Services & Miscellaneous",
    country: "Saudi Arabia",
    location: "Riyadh",
    thumbnailUrl: "https://i.postimg.cc/JnrLTwcG/9-lusidya.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1756770048613!6m8!1m7!1sCAoSF0NJSE0wb2dLRUlDQWdJQ0JzZFhENkFF!2m2!1d24.72668249838909!2d46.64411118979093!3f354.0860120475387!4f2.3144547985085495!5f0.4000000000000002",
    description: "Lucidya is an innovative software company in Riyadh specializing in AI-powered social media analytics and customer intelligence solutions for businesses across the Middle East."
  },
  {
    id: 318,
    title: "New Day Center",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/yxrxrS59/new-day-center-rolla.png",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1762033485405!6m8!1m7!1sCAoSHENJQUJJaEJyTVpwNlMxXzk5ajgzN2NoM2xVajc.!2m2!1d25.3638063805047!2d55.39198054531554!3f282.791875460552!4f-0.25105491247866496!5f0.4000000000000002",
    description: "New Day Center is a modern shopping mall in Rolla, Sharjah, offering a diverse selection of retail stores, dining options, and entertainment facilities for families and shoppers."
  },
  {
    id: 319,
    title: "Plus Mart General Trading LLC Br-1",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/4yFyFhM6/plus-mart.png",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1762034020034!6m8!1m7!1sCAoSHENJQUJJaEJTRm9fOS01S2Z3U2wtSlU1ZFAxOVo.!2m2!1d25.322654154424!2d55.38944866604695!3f335.8191425664667!4f-5.704913860676314!5f0.4000000000000002",
    description: "Plus Mart is a comprehensive shopping destination offering groceries, household essentials, and everyday items with competitive prices and convenient shopping experience in Sharjah."
  },
  {
    id: 320,
    title: "Zeyad Alobaidi Auto Spare Parts Trd",
    category: "Automotive-Related Businesses",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/J0d0dBgT/zeyad-al-obaidi.png",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1762034777978!6m8!1m7!1sCAoSHENJQUJJaENPX1ZxSkc2UEhWNVdtd2RXOEczWlI.!2m2!1d25.33240711447695!2d55.40575495218547!3f186.05064344485618!4f-7.368595361547563!5f0.4000000000000002",
    description: "Zeyad Alobaidi Auto Spare Parts Trading is a trusted auto parts supplier in Sharjah, providing quality automotive components and accessories for various vehicle makes and models."
  },
  {
    id: 321,
    title: "MK Kabbani Furniture - Sharjah",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/sx0x0Z8W/mk-kabbani-sharjah.png",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1762036135488!6m8!1m7!1sCAoSHENJQUJJaEJ6OVNGSGpLd0xsTnUzSVpGNjF5Tzc.!2m2!1d25.34007652771505!2d55.41079447730763!3f243.03371588069848!4f1.3596098033603852!5f0.4000000000000002",
    description: "MK Kabbani Furniture showcases an extensive collection of contemporary and classic furniture pieces for homes and offices, featuring quality craftsmanship and elegant designs."
  },
  {
    id: 322,
    title: "Mabrook Hardware Trading LLC",
    category: "Services & Miscellaneous",
    country: "UAE",
    location: "Ajman",
    thumbnailUrl: "https://i.postimg.cc/Bbwbw1yH/mabrook-ajman.png",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1762036693158!6m8!1m7!1sCAoSHENJQUJJaEFUS0ctWlA0SUZSMHRSWmkwV3U3RFM.!2m2!1d25.43181712831265!2d55.5231783503839!3f147.61806904095164!4f-0.08718428898178843!5f0.4000000000000002",
    description: "Mabrook Hardware Trading LLC is a professional corporate office and hardware trading company in Ajman, specializing in construction materials and industrial hardware solutions."
  },
  {
    id: 323,
    title: "VegMe - Muwaileh Sharjah",
    category: "Food & Beverage",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/yxrxrS5L/vegme-muhaila.png",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1762037030551!6m8!1m7!1sCAoSHENJQUJJaER1VzhyeXhHT2RvMjFlNmhPNmhzM08.!2m2!1d25.30667139204599!2d55.45094733767335!3f348.7338161997291!4f-1.3439721644647449!5f0.4000000000000002",
    description: "VegMe is a vibrant vegetarian restaurant in Muwaileh offering healthy, plant-based meals with fresh ingredients, creative recipes, and a welcoming atmosphere for health-conscious diners."
  },
  {
    id: 324,
    title: "Saray Deluxe Hotel Apartments",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Abu Dhabi",
    thumbnailUrl: "https://i.postimg.cc/cC5C58j9/saray-hotel.png",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1762037755755!6m8!1m7!1sCAoSHENJQUJJaEFqOG9MM1AwN0poY2IwbWV0a1JwMjg.!2m2!1d24.3985276886247!2d54.56592956384065!3f314.4488768742872!4f-1.506063025990045!5f0.4000000000000002",
    description: "Saray Deluxe Hotel Apartments offers luxurious serviced apartments in Abu Dhabi with modern amenities, spacious accommodations, and exceptional hospitality for both short and extended stays."
  },
  {
    id: 325,
    title: "Gift Mart Trading Sharjah",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/5ykykFGH/gift-mart-sharjah.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1762038086001!6m8!1m7!1sCAoSHENJQUJJaEF6U2xvSS1hOV9jRnpzWGNPRkEwMEQ.!2m2!1d25.32379641368993!2d55.40422168958928!3f278.1672575398477!4f-1.3397604919715178!5f0.4000000000000002",
    description: "Gift Mart Trading is a popular department store in Sharjah offering a wide variety of gifts, home décor, toys, stationery, and lifestyle products at affordable prices for all occasions."
  },
  {
    id: 326,
    title: "City Max Ajman",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Ajman",
    thumbnailUrl: "https://i.postimg.cc/0Q1dbW06/360-0012-citymax-ajman.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1789831759160!6m8!1m7!1sCAoSHENJQUJJaEExY0Jnc0RsT3JyZnNfOTZkZjFFdUs.!2m2!1d25.40334909619674!2d55.42909870958971!3f224.52507304043786!4f1.09528587280559!5f0.4000000000000002",
    description: "City Max Ajman is a convenient department store featuring clothing, household products, accessories, and everyday essentials for local shoppers."
  },
  {
    id: 327,
    title: "Mabrook Hardware Store - Ajman",
    category: "Building Materials & Hardware",
    country: "UAE",
    location: "Ajman",
    thumbnailUrl: "https://i.postimg.cc/cHGMr9Bv/360-0011-mabrook-hardwarestore-ajman.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1789849991642!6m8!1m7!1sCAoSHENJQUJJaEFWWERkUUdGb2JLd0tfcDd5cWZ2dDk.!2m2!1d25.42979730229597!2d55.5278216953464!3f45.8774502560348!4f-3.6951565870339778!5f0.4000000000000002",
    description: "Mabrook Hardware Store is a well-stocked Ajman warehouse supplying practical hardware, tools, and building materials for trade and construction needs."
  },
  {
    id: 328,
    title: "AZAZ Investment Real Estate LLC - UAQ",
    category: "Services & Miscellaneous",
    country: "UAE",
    location: "Umm Al Quwain",
    thumbnailUrl: "https://i.postimg.cc/26NFVc7y/360-0010-azaz-realestate.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1789850434784!6m8!1m7!1sCAoSHENJQUJJaEFCZERVOXk3UU00cngwbzNJM1NySl8.!2m2!1d25.4981686219252!2d55.55206843930961!3f69.7972200226309!4f-3.3219776401460592!5f0.4000000000000002",
    description: "AZAZ Investment Real Estate LLC supports property owners, buyers, and tenants with professional real estate services in Umm Al Quwain."
  },
  {
    id: 329,
    title: "Chee Fatt Tools & Hardware Trading LLC",
    category: "Building Materials & Hardware",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/xCVycx3c/360-0009-chee-fatt-dubai.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1789850716428!6m8!1m7!1sCAoSHENJQUJJaEJuNDZIUUdHcVhoZWRuVXd1UHJyM2Q.!2m2!1d25.28864732527548!2d55.38386968827338!3f121.48910457298759!4f-12.279289692865262!5f0.4000000000000002",
    description: "Chee Fatt Tools & Hardware Trading LLC offers professional tools, hardware, and workshop supplies for contractors and technical trades in Dubai."
  },
  {
    id: 330,
    title: "Friday Center - Sharjah",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/Ssb7JTfx/360-0008-faiday-center-sharjah.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1789851777170!6m8!1m7!1sCAoSHENJQUJJaEFYOTBRa1JtS2JrdmZRSk5TakdWMmM.!2m2!1d25.34253102966003!2d55.40729415437644!3f96.23348535542083!4f0.6598280740420819!5f0.4000000000000002",
    description: "Friday Center is a Sharjah department store offering an accessible range of household goods, clothing, gifts, and daily-use products."
  },
  {
    id: 331,
    title: "DAY STAR - Dubai",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/0Q1dbW02/360-0007-daystar-bur-dubai.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1789852022334!6m8!1m7!1sCAoSHENJQUJJaEFHdWFNcGlkS1FUaVp5V1BOYVI2WEY.!2m2!1d25.26417271639162!2d55.29186665889392!3f119.10101431863549!4f-1.7233961225691843!5f0.4000000000000002",
    description: "DAY STAR is a Bur Dubai department store with a broad selection of household essentials, fashion items, accessories, and value-focused merchandise."
  },
  {
    id: 332,
    title: "City Max - Muwailhat",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Ajman",
    thumbnailUrl: "https://i.postimg.cc/hjRbfy14/360-0006-citimax-muwailah.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1789852248168!6m8!1m7!1sCAoSHENJQUJJaEJZbWNxSXJlWjlzWFhReWp1X2JIUGM.!2m2!1d25.37841455315767!2d55.49278323082319!3f293.196285527982!4f-1.0478023771091216!5f0.4000000000000002",
    description: "City Max Muwailhat provides a varied department-store collection of apparel, homeware, accessories, and practical everyday products."
  },
  {
    id: 333,
    title: "Al Tatweer Tower - UAQ",
    category: "Services & Miscellaneous",
    country: "UAE",
    location: "Umm Al Quwain",
    thumbnailUrl: "https://i.postimg.cc/NMv75Jks/360-0005-tatweer-tower-uaq.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1789852564443!6m8!1m7!1sCAoSHENJQUJJaER5LUFHUlJjdmpVWEM1ZkM3VTl1TlU.!2m2!1d25.49267857635582!2d55.55160683390275!3f319.08285157143257!4f1.1165479886598462!5f0.4000000000000002",
    description: "Al Tatweer Tower is a residential apartment building in Umm Al Quwain offering conveniently located urban accommodation."
  },
  {
    id: 334,
    title: "The Mattress Store Outlet",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Umm Al Quwain",
    thumbnailUrl: "https://i.postimg.cc/5tCS9dLF/360-0004-metress-store-uaq.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1789853458689!6m8!1m7!1sCAoSHENJQUJJaEFrNFQwU3FnRzVjd1kzOHkwYm55U3M.!2m2!1d25.5348739471608!2d55.70454064645433!3f356.22712897464044!4f-3.3521404199391043!5f0.4000000000000002",
    description: "The Mattress Store Outlet presents mattresses, bedding, and sleep accessories designed for different comfort preferences and home needs."
  },
  {
    id: 335,
    title: "New Day Center",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Sharjah",
    thumbnailUrl: "https://i.postimg.cc/cJnB1ywg/360-0003-newday-center-sharjah.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1789855043561!6m8!1m7!1sCAoSHENJQUJJaEFiYUdBY1B4WTZ1eDhqSUlQeFdOVHQ.!2m2!1d25.36385538122029!2d55.39190884670945!3f171.70562781120978!4f-3.293143580470044!5f0.4000000000000002",
    description: "New Day Center is a welcoming Sharjah department store featuring affordable fashion, household goods, accessories, and useful everyday items."
  },
  {
    id: 336,
    title: "AZAZ Garage LLC",
    category: "Services & Miscellaneous",
    country: "UAE",
    location: "Umm Al Quwain",
    thumbnailUrl: "https://i.postimg.cc/fb9fWnmS/360-0002-azaz-garage.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1789858240468!6m8!1m7!1sCAoSHENJQUJJaEJLbGlhNm8xYnNRWTRmZGNhT1VFbjA.!2m2!1d25.5415888694169!2d55.70531654535657!3f244.60143645679094!4f0.031868554421677686!5f0.7820865974627469",
    description: "AZAZ Garage LLC provides vehicle inspection, maintenance, and repair services from its equipped workshop in Umm Al Quwain."
  },
  {
    id: 337,
    title: "Gift Point - Deira",
    category: "Home & Lifestyle",
    country: "UAE",
    location: "Dubai",
    thumbnailUrl: "https://i.postimg.cc/zfgFDZKL/360-0001-giftmart-deira.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1789859415862!6m8!1m7!1sCAoSHENJQUJJaEJwUHBwLUNfRFdrTU9QcDM5OGZNWE8.!2m2!1d25.27114390850825!2d55.31583783233979!3f300.9211714732061!4f-2.1010951301007452!5f0.4000000000000002",
    description: "Gift Point Deira offers gifts, home accessories, toys, stationery, and affordable lifestyle products for everyday shopping and special occasions."
  },
  {
    id: 338,
    title: "Injaz Zone Real Estate L L C",
    category: "Services & Miscellaneous",
    country: "UAE",
    location: "Umm Al Quwain",
    thumbnailUrl: "https://i.postimg.cc/yNZy64cD/360-0000-injaz-realestate.jpg",
    tourUrl: "https://www.google.com/maps/embed?pb=!4v1789859653354!6m8!1m7!1sCAoSHENJQUJJaEIwTnBIQ0JGbm9SdlkzMHhNV2ZmazM.!2m2!1d25.54206429196366!2d55.73090363122247!3f29.361511549060374!4f-4.044135741219961!5f0.7820865974627469",
    description: "Injaz Zone Real Estate L L C assists clients with property sales, leasing, and local real estate opportunities in Umm Al Quwain."
  }
];

// Export unique categories for filtering
export const getUniqueCategories = () => {
  const categories = portfolioItems.map(item => item.category);
  return Array.from(new Set(categories)).sort();
};

// Export unique countries for filtering
export const getUniqueCountries = () => {
  const countries = portfolioItems.map(item => item.country);
  return Array.from(new Set(countries)).sort();
};
